import { Injector } from '@angular/core';
import { TALKING_POINTS_LIST_APP_STATE_SLICE_KEY, TALKING_POINTS_LIST_STATE_KEYS } from '../state/constants';
import { AppStateService } from 'NewAngular/services/app-state.service';
import * as i0 from "@angular/core";
export class TalkingPointsListAppStateService {
    constructor(injector) {
        this.injector = injector;
    }
    get appStateService() {
        if (this._appStateService === undefined) {
            this._appStateService = this.injector.get(AppStateService, null);
        }
        return this._appStateService;
    }
    initAppState() {
        if (!this.appStateService)
            return;
        this.appStateService.setStateSlice(TALKING_POINTS_LIST_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(TALKING_POINTS_LIST_STATE_KEYS);
        this.appStateService.start();
    }
    get enabled() {
        return this.appStateService?.enabled ?? false;
    }
}
TalkingPointsListAppStateService.ɵfac = function TalkingPointsListAppStateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointsListAppStateService)(i0.ɵɵinject(i0.Injector)); };
TalkingPointsListAppStateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TalkingPointsListAppStateService, factory: TalkingPointsListAppStateService.ɵfac, providedIn: 'root' });
